import * as React from "react"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { cn } from "@/lib/utils"

export interface AdminCardProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string
  description?: string
  accentColor?: "primary" | "success" | "warning" | "danger" | "info"
  children: React.ReactNode
}

const accentColorMap = {
  primary: "bg-admin-primary",
  success: "bg-admin-success",
  warning: "bg-admin-warning",
  danger: "bg-admin-danger",
  info: "bg-admin-info",
}

export function AdminCard({
  title,
  description,
  accentColor = "primary",
  children,
  className,
  ...props
}: AdminCardProps) {
  return (
    <Card className={cn("relative overflow-hidden", className)} {...props}>
      {/* Gradient accent bar */}
      <div className={cn("absolute top-0 left-0 right-0 h-1", accentColorMap[accentColor])} />
      
      <CardHeader>
        {title && <CardTitle className="text-admin-card">{title}</CardTitle>}
        {description && <CardDescription className="text-admin-label">{description}</CardDescription>}
      </CardHeader>
      
      <CardContent>
        {children}
      </CardContent>
    </Card>
  )
}

